<template>
  <div>
    <div class="top-info-wrapper">
      <div class="page-wrapper">
        <div class="top-info">
          <div class="top-info__title">
            PGA TOUR’s Impact
          </div>
        </div>
        <div class="top-info__description">
          <p>
            Through the world of golf, the PGA TOUR and PGA TOUR Charities, Inc.
            have generated over $29 million for Atlanta charities since 1998,
            and recently surpassed $3 billion in all-time giving nationwide. You
            can directly help support the TOUR Championship’s extensive work
            with local charities, which last year alone garnered $3.5 million
            from <span style="white-space: nowrap">the tournament.</span>
          </p>
          <p>
            With the loss of in-person attendance due to COVID-19, these
            organizations need our help more than ever in order to continue
            offering life-changing services to the East Lake community, which
            serves as a national model for responsible and sustainable
            <span style="white-space: nowrap">urban renewal.</span>
          </p>
        </div>
      </div>
    </div>
    <div>
      <div class="our-impact-grid" ref="grid">
        <!--<SearchInput v-model="search" />-->
        <Grid :items="memories" :impactLayout="true" />
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "OurImpactPage",
  metaInfo: {
    titleTemplate: "%s - Our Impact",
  },
  data() {
    return {
      search: "",
      memories: [],
      page: 1,
      infiniteId: +new Date(),
    };
  },
  mounted() {
    this.fetchMemories();
  },
  methods: {
    async fetchMemories($state) {
      const params = {
        page: this.page,
        query: this.search,
        self_posted: true,
        sort_by: "position",
      };
      const { data } = await this.$api.Memory.query(params);
      this.page += 1;
      const ids = this.memories.map((t) => t.id);
      const newData = data.filter((t) => !ids.includes(t.id));

      this.memories.push(...newData);

      if (data.length) {
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    setInfiniteId: _.debounce(function() {
      this.page = 1;
      this.memories = [];
      this.infiniteId += 1;
    }, 300),
  },
  watch: {
    search() {
      this.setInfiniteId();
    },
  },
};
</script>

<style lang="scss" scoped>
.top-info-wrapper {
  background-image: url("~@/assets/top-info.jpg");
  min-height: 290px;
  background-size: cover;
  background-position: center;
}

.top-info {
  padding-bottom: 9px;
  padding-top: 65px;
}

.top-info__title {
  font-family: "Roboto Condensed";
  color: white;
  font-weight: bold;
  margin-bottom: 20px;
}

.top-info__description {
  color: white;
  padding: 15px 0;
  max-width: 700px;
  margin: auto;
}
.our-impact-grid {
  display: flex;
  flex-wrap: wrap;
  margin: 63px 36px;
  justify-content: space-between;
}

@media screen and (max-width: 600px) {
  .our-impact-grid {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
  }
  .top-info-wrapper {
    background-image: url("~@/assets/top-info-mobile.jpg");
    background-position-x: 0;
  }
}
</style>
